RivalIQ.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.Select = Marionette.ItemView.extend({
        template: '#selectTemplate',
        valueField: 'id',
        nameField: 'name',

        ui: {
            dropdown: '.dropdown-selector',
            btn: '.dropdown-toggle',
            items: '.riq-select-dropdown-content > :not(.disabled)',
            popovers: '[data-toggle="popover"]'
        },

        behaviors: function () {
            const me = this;

            // need to use getOption as this function is run before the initializer
            let selectInitialOnRender = me.getOption('selectInitialOnRender');
            if (_.isUndefined(selectInitialOnRender)) {
                selectInitialOnRender = true;
            }

            return {
                Localizable: {},
                DropdownSelector: {
                    selectInitialOnRender: selectInitialOnRender,
                    menuItemSelector: '.dropdown-selector [data-selectable]'
                }
            };
        },

        events: {
            'show.bs.dropdown @ui.dropdown': 'resetActive',
            'mouseenter @ui.items': 'setActive'
        },

        resetActive: function () {
            const me = this;
            me.ui.items.removeClass('active');
            me.$('.selected').addClass('active');
        },

        setActive: function (e) {
            const me = this;
            me.ui.items.removeClass('active');
            $(e.currentTarget).addClass('active');
        },

        defaultSelector: function () {
            const me = this;
            // NOTE || '' allows correct handling of undefined
            const val = (_.isUndefined(me.selected) || _.isNull(me.selected) ? '' : me.selected);
            return `[data-value="${val}"]`;
        },

        isDisabled: function () {
            const me = this;

            return me.items.length < 2 ||
                (_.isUndefined(me.selected) && !_.find(me.items, function (item) {
                    return _.isUndefined(item[me.valueField]);
                }));
        },

        onRender: function () {
            const me = this;
            me.ui.btn.dropdown();
            me.ui.btn.toggleClass('disabled', me.isDisabled());

            me.ui.popovers.popover();
        },

        serializeData: function () {
            const me = this;

            return {
                name: me.name,
                items: me.items,
                valueField: me.valueField,
                nameField: me.nameField,
                itemRenderer: me.itemRenderer,
                selectLabel: me.selectLabel || ''
            };
        },

        setItems: function (items, selected) {
            const me = this;

            me.items = items;
            me.selected = selected;

            me.render();
            me.triggerMethod('render:loaded');
            me.ui.btn.toggleClass('disabled', me.isDisabled());
        },

        onSelectDropdown: function (data) {
            const me = this;
            const $selectEl = $(me.selectEl);
            $(me.selectOptionEl).val(data.value);

            $selectEl.val(data.value);
            me.onChange(data.value);
            $selectEl.trigger('change');
            me.ui.btn.toggleClass('disabled', me.isDisabled());
        },

        onChange: _.noop,

        initialize: function (options) {
            const me = this;
            _.extend(me, options);
        },

        constructor: function (options) {
            const me = this;

            options.selectEl = options.el;
            options.selectOptionEl = document.createElement('option');

            options.selectEl.append(options.selectOptionEl);
            options.el = document.createElement('div');

            $(options.el).insertAfter(options.selectEl);
            $(options.selectEl).addClass('hide');

            Marionette.View.call(me, options);
        }
    });
});
